import { currentUserQuery } from "@common/api/users"
import { hasPermission } from "@common/lib/permissions"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { ProfileForm } from "./-components/form/profile-form"
import { PROFILE_PERMISSION } from "./-lib/permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/account/profile",
)({
  staticData: {
    breadcrumb: [
      { label: "Account - Profile", href: "/settings/account/profile" },
    ],
  },
  beforeLoad: async ({ context: { queryClient } }) => {
    const user = await queryClient.ensureQueryData(currentUserQuery())
    if (!hasPermission(user, PROFILE_PERMISSION)) {
      throw redirect({ to: "/settings/workspace/general" })
    }
  },
  component: AccountProfilePage,
})

function AccountProfilePage(): React.ReactElement {
  const { data: user } = useSuspenseQuery(currentUserQuery())
  const showToast = useCustomToast()

  return (
    <PageContent>
      <PageTitle title="Profile" />
      <ProfileForm
        user={user}
        onSave={() =>
          showToast("Saved", "Your profile has been updated.", "success")
        }
      />
      <Outlet />
    </PageContent>
  )
}
